module.exports = __webpack_public_path__ + "static/media/2-1.6436b744.jpg";